import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Highlight } from 'ngx-highlightjs';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../../component-examples/component-examples.constants';
import { UILAB_NG_MAT_COMPONENTS_PACKAGE } from '../../../shared/constants/dependencies.constants';

@Component({
    selector: 'avd-styling-get-started',
    standalone: true,
    templateUrl: './styling-get-started.component.html',
    styleUrls: ['./styling-get-started.component.scss'],
    imports: [Highlight, RouterLink],
})
export class StylingGetStartedComponent {
    readonly ngMatComponentsPackage = UILAB_NG_MAT_COMPONENTS_PACKAGE;

    readonly scssTokenMapImport =
        "@use '@uilab/styling/scss/shared/css-variable-names' as uilabTokens;";

    readonly stylingPackageLink =
        COMPONENT_EXAMPLES_CONSTANTS.STYLING_PACKAGE_LINK;

    readonly ngMatComponentsPackageLink =
        COMPONENT_EXAMPLES_CONSTANTS.NG_MAT_COMPONENTS_PACKAGE_LINK;

    readonly angularMaterialThemePackageLink =
        COMPONENT_EXAMPLES_CONSTANTS.ANGULAR_MATERIAL_THEME_PACKAGE_LINK;

    readonly componentsGetStartedLink =
        COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;

    readonly installCommand = 'npm install @uilab/styling';

    readonly angularJsonStylesSnippet = `"styles": [
  ...
  "@uilab/styling/css/light-css-variables.css",
  "@uilab/styling/css/dark-css-variables.css"
]`;

    readonly cssTokenUsageSnippet = `.page {
  background-color: var(--uilab-sys-color-app-background-default);
  color: var(--uilab-sys-color-text-neutral-high-emphasis);
  font: var(--uilab-sys-typography-system-body-1);
}`;

    readonly scssHelperSnippet = `@use 'sass:map';
${this.scssTokenMapImport}

.page {
  color: var(
    map.get(uilabTokens.$css-var, uilab-sys-color-text-neutral-high-emphasis)
  );
}`;

    readonly scssMapExampleSnippet = `@use 'sass:map';
${this.scssTokenMapImport}

$theme-container-regular-neutral: (
  opaque: var(#{map.get(uilabTokens.$css-var, uilab-sys-color-container-regular-neutral-opaque)}),
  light: var(#{map.get(uilabTokens.$css-var, uilab-sys-color-container-regular-neutral-light)}),
  subtle: var(#{map.get(uilabTokens.$css-var, uilab-sys-color-container-regular-neutral-subtle)}),
);

$theme-container-inverse-regular-neutral: (
  opaque: var(#{map.get(uilabTokens.$css-var, uilab-sys-color-inverse-container-regular-neutral-opaque)}),
  light: var(#{map.get(uilabTokens.$css-var, uilab-sys-color-inverse-container-regular-neutral-light)}),
  subtle: var(#{map.get(uilabTokens.$css-var, uilab-sys-color-inverse-container-regular-neutral-subtle)}),
);

.example {
  background-color: map.get($theme-container-regular-neutral, light);
  border: 1px solid map.get($theme-container-regular-neutral, subtle);
}`;

    readonly themeSnippet = `document.documentElement.setAttribute('data-theme', 'light');
// Toggle to dark when needed
// document.documentElement.setAttribute('data-theme', 'dark');`;
}
